// format date to "DD.MM.YYYY"

export const formatDate = (value) => {
  let date = new Date(value);
  const day = date.toLocaleString('default', { day: '2-digit' });
  const month = date.toLocaleString('default', { month: '2-digit' });
  const year = date.toLocaleString('default', { year: 'numeric' });
  return day + '.' + month + '.' + year;
}